/** Diccionario base (español). La forma de este objeto define las claves válidas. */
const es = {
  brand: {
    tagline: 'Aprende, practica y compite escribiendo',
  },
  nav: {
    home: 'Inicio', learn: 'Aprender', practice: 'Practicar', test: 'Speed Test', games: 'Juegos', compete: 'Competición',
    stats: 'Estadísticas', profile: 'Perfil', settings: 'Ajustes', certificates: 'Certificados', admin: 'Administración',
    login: 'Entrar', register: 'Crear cuenta', logout: 'Cerrar sesión', menu: 'Menú', mainNav: 'Navegación principal',
    themeToggle: 'Cambiar tema claro/oscuro', skipToContent: 'Saltar al contenido', language: 'Idioma de la interfaz', account: 'Cuenta',
  },
  common: {
    loading: 'Cargando…', error: 'Algo ha fallado', retry: 'Reintentar', save: 'Guardar', saved: 'Guardado', cancel: 'Cancelar',
    close: 'Cerrar', delete: 'Eliminar', edit: 'Editar', create: 'Crear', back: 'Volver', next: 'Siguiente', continue: 'Continuar',
    start: 'Empezar', restart: 'Reiniciar', pause: 'Pausa', resume: 'Reanudar', yes: 'Sí', no: 'No', search: 'Buscar', all: 'Todos',
    guest: 'Invitado', signIn: 'Entrar', signUp: 'Crear cuenta gratis', seeAll: 'Ver todo', wpm: 'WPM', cpm: 'CPM',
    accuracy: 'Precisión', raw: 'Bruto', consistency: 'Consistencia', errors: 'Errores', time: 'Tiempo', words: 'palabras',
    chars: 'caracteres', level: 'Nivel', xp: 'XP', empty: 'Todavía no hay datos.', language: 'Idioma', mode: 'Modo',
    duration: 'Duración', seconds: 's', actions: 'Acciones', status: 'Estado', copy: 'Copiar', copied: 'Copiado',
    print: 'Imprimir / PDF', previous: 'Anterior', nextPage: 'Siguiente', of: 'de', private: 'Privado', public: 'Público',
    signInToUse: 'Inicia sesión para usar esta función.', optional: 'opcional', date: 'Fecha', user: 'Usuario',
    country: 'País', score: 'Puntuación', rank: 'Puesto', tests: 'Pruebas', value: 'Valor', none: 'Ninguno',
  },
  langs: { es: 'Español', en: 'Inglés' },
  layouts: { 'es-qwerty': 'Español (QWERTY)', 'en-qwerty': 'Inglés (QWERTY US)' },
  modes: {
    words: 'Palabras', phrases: 'Frases', texts: 'Textos', numbers: 'Números', punctuation: 'Puntuación', symbols: 'Símbolos',
    custom: 'Personalizado', letters: 'Letras', combos: 'Combinaciones', weak: 'Puntos débiles',
  },
  kinds: { test: 'Speed test', practice: 'Práctica', lesson: 'Lección', challenge: 'Desafío', race: 'Carrera' },
  tiers: { beginner: 'Principiante', basic: 'Básico', intermediate: 'Intermedio', advanced: 'Avanzado', expert: 'Experto' },
  categories: {
    intro: 'Introducción', theory: 'Teoría', home_row: 'Fila central', top_row: 'Fila superior', bottom_row: 'Fila inferior',
    capitals: 'Mayúsculas', numbers: 'Números', punctuation: 'Puntuación', symbols: 'Símbolos', combined: 'Combinados',
    words: 'Palabras', phrases: 'Frases', paragraphs: 'Párrafos', advanced: 'Avanzado',
  },
  home: {
    eyebrow: 'Gratis · Sin anuncios · Español e inglés',
    title1: 'Escribe sin mirar.',
    title2: 'Escribe sin límites.',
    lead: 'ManiType reúne academia, práctica guiada, pruebas de velocidad, juegos y competición en un solo lugar. Empieza ahora mismo, sin registrarte.',
    ctaTest: 'Hacer un speed test',
    ctaLearn: 'Empezar desde cero',
    tryNow: 'Pruébalo aquí mismo: empieza a escribir',
    statsTitle: 'La comunidad en cifras reales',
    statUsers: 'personas registradas',
    statTests: 'pruebas completadas',
    statKeystrokes: 'pulsaciones verificadas',
    statToday: 'pruebas hoy',
    statsEmpty: 'Aún no hay pruebas registradas. ¡Sé la primera persona del ranking!',
    featuresTitle: 'Todo lo que necesitas para escribir mejor',
    features: {
      learnTitle: 'Academia progresiva',
      learnText: 'De la postura y la fila central hasta párrafos completos, en cinco niveles con objetivos claros.',
      testTitle: 'Métricas honestas',
      testText: 'WPM neto y bruto, CPM, precisión y consistencia con fórmulas públicas y verificadas en el servidor.',
      smartTitle: 'Entrenamiento inteligente',
      smartText: 'Detecta tus teclas, combinaciones y palabras problemáticas y te propone ejercicios a medida.',
      gamesTitle: 'Juegos de mecanografía',
      gamesText: 'Defiende tu base, gana al reloj o sobrevive: practicar también puede ser divertido.',
      competeTitle: 'Competición limpia',
      competeText: 'Rankings por idioma, desafíos diarios, semanales y mensuales y carreras en tiempo real.',
      certTitle: 'Certificados verificables',
      certText: 'Demuestra tu nivel con un certificado con código de verificación público.',
    },
    rankingTitle: 'Los más rápidos · 60 segundos',
    rankingEmpty: 'El ranking está vacío. Los resultados aparecen aquí cuando alguien completa una prueba clasificatoria.',
    academyTitle: 'Aprende desde la primera tecla',
    academyText: 'Lecciones cortas con teclado interactivo que te muestra qué dedo usar. Avanza a tu ritmo o elige ejercicios libremente.',
    gamesTitle: 'Practica jugando',
    competeTitle: 'Mide tu nivel contra el mundo',
    competeText: 'Participa en el desafío del día, sube en los rankings semanales o reta a tus amistades a una carrera.',
  },
  typing: {
    clickToFocus: 'Haz clic aquí o pulsa cualquier tecla para escribir',
    paused: 'En pausa',
    pausedHint: 'Pulsa Esc o haz clic para reanudar',
    restartHint: 'Tab · reiniciar',
    pauseHint: 'Esc · pausa',
    capsLock: 'Bloq Mayús activado',
    area: 'Área de escritura',
    timeLeft: 'Tiempo restante',
    progress: 'Progreso',
    waiting: 'Empieza a escribir para iniciar el cronómetro',
  },
  test: {
    title: 'Speed Test',
    subtitle: 'Mide tu velocidad y precisión reales.',
    time: 'Tiempo',
    wordsCount: 'Palabras',
    custom: 'Personalizada',
    customDuration: 'Duración personalizada (segundos)',
    content: 'Contenido',
    customText: 'Tu texto',
    customTextPlaceholder: 'Pega o escribe el texto que quieres practicar…',
    exerciseLanguage: 'Idioma del ejercicio',
    rankedBadge: 'Clasificatoria',
    unrankedBadge: 'No puntúa en rankings',
    rankedHint: 'Las pruebas de palabras con 15, 30, 60 o 120 s cuentan para los rankings.',
    guestNotice: 'Estás como invitado: tus resultados se guardan solo en este navegador.',
    loadingText: 'Preparando el texto…',
    apply: 'Aplicar',
  },
  results: {
    title: 'Resultado',
    official: 'Resultado verificado por el servidor',
    local: 'Resultado calculado en tu navegador',
    net: 'WPM neto',
    raw: 'WPM bruto',
    cpm: 'CPM',
    accuracy: 'Precisión',
    consistency: 'Consistencia',
    errors: 'Errores',
    corrections: 'Correcciones',
    uncorrected: 'Sin corregir',
    backspaces: 'Retrocesos',
    time: 'Tiempo',
    chars: 'Caracteres',
    score: 'Puntuación',
    xp: 'XP ganada',
    newRecord: '¡Nuevo récord personal!',
    previousRecord: 'Récord anterior: {wpm} WPM',
    ranked: 'Cuenta para el ranking',
    flagged: 'Resultado en revisión: la velocidad es excepcional y un moderador la verificará.',
    timeline: 'Evolución durante la prueba',
    achievements: 'Logros desbloqueados',
    levelUp: '¡Subes al nivel {level}!',
    streak: 'Días de racha: {days}',
    tryAgain: 'Repetir',
    next: 'Nueva prueba',
    saveCta: 'Crea una cuenta para guardar tu historial en la nube, entrar en los rankings y ganar logros.',
    formulas: 'Cómo se calcula',
    formulaText: 'WPM neto = caracteres correctos ÷ 5 ÷ minutos. WPM bruto = todas las pulsaciones ÷ 5 ÷ minutos. Precisión = pulsaciones correctas ÷ pulsaciones. Los errores corregidos también cuentan.',
    rejected: 'El servidor no ha aceptado el resultado ({reason}).',
    saving: 'Guardando resultado…',
    tooltip: 'Segundo {s}: {wpm} WPM · bruto {raw} · {errors} errores',
  },
  practice: {
    title: 'Zona de práctica',
    subtitle: 'Entrena exactamente lo que necesitas. Puedes pausar cuando quieras.',
    options: {
      letters: 'Letras concretas', lettersText: 'Elige las letras que quieres reforzar.',
      words: 'Palabras', wordsText: 'Palabras frecuentes del idioma.',
      phrases: 'Frases', phrasesText: 'Frases cortas con mayúsculas y signos.',
      texts: 'Párrafos', textsText: 'Textos largos para ganar resistencia.',
      numbers: 'Números', numbersText: 'Cifras, decimales y cantidades.',
      symbols: 'Símbolos', symbolsText: '@ # $ % & ( ) [ ] { } y más.',
      punctuation: 'Puntuación', punctuationText: 'Comas, puntos, ¿preguntas? y ¡exclamaciones!',
      combos: 'Combinaciones difíciles', combosText: 'Grupos de letras que suelen costar.',
      weak: 'Mis puntos débiles', weakText: 'Ejercicio generado con tus teclas con más errores.',
      custom: 'Texto propio', customText: 'Practica con cualquier texto o lista de palabras.',
    },
    lettersLabel: 'Letras a practicar',
    lettersPlaceholder: 'p. ej. ñ,qp',
    customAsList: 'Tratar como lista de palabras (orden aleatorio)',
    length: 'Longitud',
    stopOnError: 'Detenerse en cada error',
    weakNone: 'Todavía no hay suficientes datos de tus errores. Haz algunas pruebas primero.',
    weakUsing: 'Teclas a reforzar: {keys}',
    start: 'Empezar práctica',
    change: 'Cambiar ejercicio',
  },
  learn: {
    title: 'Academia',
    subtitle: 'Un camino progresivo desde la posición de las manos hasta la velocidad experta.',
    courseProgress: '{done} de {total} lecciones completadas',
    continue: 'Continuar donde lo dejé',
    lesson: 'Lección',
    objective: 'Objetivo',
    instructions: 'Instrucciones',
    aboutLesson: 'Objetivo e instrucciones',
    newKeys: 'Teclas nuevas',
    targets: 'Meta: {wpm} WPM y {acc} % de precisión',
    exercise: 'Ejercicio {n} de {total}',
    startExercise: 'Empezar ejercicio',
    evaluation: 'Evaluación',
    passed: '¡Ejercicio superado!',
    failed: 'Necesitas al menos un {acc} % de precisión para superar el ejercicio.',
    recommendation: {
      repeat_accuracy: 'Repite el ejercicio con calma: prioriza no cometer errores.',
      practice_speed: 'Bien hecho. Cuando te sientas cómodo, intenta ir un poco más rápido para ganar la segunda estrella.',
      continue: 'Buen ritmo. Puedes pasar al siguiente ejercicio o mejorar la precisión para la tercera estrella.',
      excellent: '¡Excelente! Has dominado este ejercicio.',
    },
    lessonCompleted: '¡Lección completada!',
    nextLesson: 'Siguiente lección',
    nextExercise: 'Siguiente ejercicio',
    repeat: 'Repetir',
    allLessons: 'Todas las lecciones',
    guestProgress: 'Tu progreso se guarda en este navegador. Crea una cuenta para conservarlo en la nube.',
    stars: '{n} de 3 estrellas',
    keyboardLegend: 'Cada color corresponde a un dedo',
    fingers: {
      lp: 'Meñique izq.', lr: 'Anular izq.', lm: 'Corazón izq.', li: 'Índice izq.', ri: 'Índice der.', rm: 'Corazón der.',
      rr: 'Anular der.', rp: 'Meñique der.', th: 'Pulgares',
    },
  },
  games: {
    title: 'Juegos',
    subtitle: 'Mejora jugando. Los récords de invitado se guardan en este navegador.',
    play: 'Jugar',
    best: 'Tu récord: {score}',
    plays: 'Partidas: {n}',
    leaderboard: 'Mejores puntuaciones',
    score: 'Puntos',
    lives: 'Vidas',
    wave: 'Oleada',
    level: 'Nivel',
    timeLeft: 'Tiempo',
    gameOver: 'Fin de la partida',
    newRecord: '¡Nuevo récord!',
    playAgain: 'Jugar otra vez',
    startHint: 'Pulsa una tecla o el botón para empezar',
    startHintEnter: 'Elige y pulsa Intro o el botón para empezar',
    startHintTouch: 'Toca «Jugar» y escribe con el teclado de tu dispositivo',
    typeHint: 'Escribe la palabra resaltada',
    paused: 'Juego en pausa',
    stats: '{words} palabras · {wpm} WPM · {acc} % de precisión',
    disabled: 'Este juego no está disponible ahora mismo.',
    points: 'puntos',
  },
  icecream: {
    scene: 'Heladería al aire libre con clientes en la acera',
    sign: 'Heladería',
    typeHint: 'Escribe el sabor que pide un cliente',
    open: '¡Abrimos!',
    howTo: 'Escribe el sabor que pide cada cliente para servirle su bola',
    tips: 'Propinas',
    streak: 'Racha',
    rating: 'Valoración',
    quick: '¡rápido!',
    starBack: '¡Cliente encantado!',
    leftWaiting: 'Se cansó de esperar',
    levelBanner: '¡Nivel {n}!',
    rush: 'Hora punta: llegan más clientes',
    closing: 'La heladería cierra por hoy',
    served: 'Clientes servidos: {n}',
    summary: 'Nivel {level} · mejor racha: {combo} bolas',
  },
  kites: {
    sky: 'Cielo con cometas de palabras',
    typeHint: 'Escribe la palabra de una cometa',
    howTo: 'Escribe la palabra de una cometa para atraparla antes de que se aleje',
    waveBanner: '¡Oleada {n}!',
    faster: 'Más cometas y más rápidas',
    combo: 'Combo',
    caught: 'Cometas atrapadas: {n}',
    reachedWave: 'Llegaste a la oleada {n}',
  },
  rally: {
    track: 'Pista de Typing Rally',
    rival1: 'Turbo',
    rival2: 'Chispa',
    rival3: 'Centella',
    place: 'Puesto',
    rivalsPace: 'Rivales',
    chooseLevel: 'Elige tu nivel',
    levelInfo: 'rivales a {pace} WPM · puntos ×{mult}',
    distance: 'Distancia de la carrera',
    distances: { short: 'Corta', medium: 'Media', long: 'Larga' },
    tier1: 'Principiante',
    tier2: 'Aprendiz',
    tier3: 'Amateur',
    tier4: 'Aficionado',
    tier5: 'Piloto',
    tier6: 'Profesional',
    tier7: 'Experto',
    tier8: 'Campeón',
    tier9: 'Leyenda',
    tier10: 'Imparable',
    closing: 'Cierre de meta',
    getReady: 'Atento al semáforo: tu coche solo avanza con letras correctas.',
    finishedPlace: '{n}.º puesto',
    notFinished: 'No llegaste a tiempo a la meta',
    levelUp: '¡Subes al nivel {n}!',
    levelDown: 'Bajas al nivel {n} para la próxima carrera.',
    levelSame: 'Sigues en el nivel {n}. Gana para subir.',
  },
  compete: {
    title: 'Competición',
    subtitle: 'Rankings por idioma calculados solo con resultados verificados.',
    tabs: { rankings: 'Rankings', challenges: 'Desafíos', races: 'Carreras', records: 'Récords' },
    type: { speed: 'Velocidad', accuracy: 'Precisión', score: 'Puntuación', xp: 'Nivel' },
    period: { all: 'Histórico', weekly: 'Semanal', monthly: 'Mensual' },
    accuracyRule: 'Media de precisión con al menos {n} pruebas en el periodo.',
    scoreRule: 'Suma de puntuaciones (WPM × precisión²) de las pruebas del periodo.',
    you: 'Tú',
    yourPosition: 'Tu posición: #{rank}',
    notRanked: 'Todavía no apareces en este ranking.',
    empty: 'Nadie ha puntuado todavía en este ranking. ¡Puedes ser el primero!',
    updated: 'Actualizado {time}',
    challengesIntro: 'Todos escriben el mismo texto. Supera el objetivo para ganar XP extra.',
    goal: 'Objetivo: {wpm} WPM con {acc} %',
    endsIn: 'Termina en {time}',
    participants: 'Participantes: {n}',
    accept: 'Aceptar desafío',
    completed: 'Objetivo cumplido',
    yourBest: 'Tu mejor marca: {score} puntos ({wpm} WPM)',
    bestScore: 'Tu mejor puntuación: {score}',
    period_daily: 'Diario',
    period_weekly: 'Semanal',
    period_monthly: 'Mensual',
    recordsIntro: 'Las mejores marcas de siempre por duración.',
    guestChallenges: 'Juegas como invitado: tu marca se guarda en este navegador, pero no entra en el ranking del desafío ni da XP.',
    guestOutcome: 'Como invitado, tu marca se guarda solo en este navegador.',
    joinRanking: 'Crear cuenta para entrar en el ranking',
  },
  races: {
    lobby: 'Salas abiertas',
    create: 'Crear sala',
    private: 'Sala privada (solo con código)',
    joinCode: 'Unirse con código',
    join: 'Unirse',
    noRooms: 'No hay salas públicas abiertas. ¡Crea una!',
    host: 'Anfitrión',
    players: 'Jugadores',
    waiting: 'Esperando jugadores…',
    shareCode: 'Comparte este código: {code}',
    ready: 'Estoy listo',
    notReady: 'No estoy listo',
    start: 'Empezar carrera',
    needPlayers: 'Se necesitan al menos 2 jugadores.',
    countdown: 'La carrera empieza en {s}…',
    go: '¡Ya!',
    finished: 'Carrera terminada',
    position: '{n}.º puesto',
    disqualified: 'Descalificado',
    left: 'Abandonó',
    leave: 'Salir de la sala',
    connectionLost: 'Se perdió la conexión con la sala.',
    disabled: 'Las carreras están desactivadas temporalmente.',
    history: 'Tus últimas carreras',
    you: 'Tú',
    arrived: '{name} llega a la meta en {n}.º lugar',
    guest: 'invitado',
    isReady: 'Listo',
    guestName: 'Tu apodo',
    guestNameHint: 'Entre 3 y 20 letras o números. Compites sin cuenta: tus carreras no se guardan ni dan XP.',
    guestDefault: 'Piloto',
    guestResult: 'Resultado validado. Crea una cuenta para guardar tus carreras y ganar XP.',
  },
  stats: {
    title: 'Estadísticas',
    subtitle: 'Tu evolución, calculada con pruebas realmente completadas.',
    guestNotice: 'Estás viendo las estadísticas guardadas en este navegador.',
    summary: {
      tests: 'Pruebas', avgWpm: 'WPM medio', bestWpm: 'Mejor WPM', avgAccuracy: 'Precisión media', bestAccuracy: 'Mejor precisión',
      words: 'Palabras escritas', keystrokes: 'Pulsaciones', practiceTime: 'Tiempo de práctica', errors: 'Errores', consistency: 'Consistencia media',
    },
    evolution: 'Evolución',
    granularity: { day: 'Diario', week: 'Semanal', month: 'Mensual', history: 'Histórico' },
    filters: 'Filtros',
    allLanguages: 'Todos los idiomas',
    allModes: 'Todos los modos',
    allKinds: 'Todas las actividades',
    kindFilter: 'Tipo de actividad',
    byLanguage: 'Por idioma',
    byMode: 'Por modalidad',
    heatmap: 'Mapa de errores por tecla',
    heatmapHint: 'Cuanto más intenso el color, mayor tasa de error.',
    recent: 'Últimas pruebas',
    training: 'Entrenamiento inteligente',
    goals: 'Tus objetivos: {wpm} WPM y {acc} % de precisión',
    tierNow: 'Nivel actual estimado: {tier}',
    trend: { up: 'Mejorando (+{d} WPM)', down: 'Bajando ({d} WPM)', flat: 'Estable', insufficient: 'Faltan datos para ver tendencia' },
    weakKeys: 'Teclas con más errores',
    problemWords: 'Palabras problemáticas',
    weakBigrams: 'Combinaciones difíciles',
    errorRate: '{rate} % de error',
    doIt: 'Hacerlo ahora',
    noRecs: 'Sin recomendaciones por ahora: ¡sigue practicando!',
    level: 'Progreso de nivel',
    xpToNext: '{xp} XP para el nivel {level}',
    achievements: 'Logros',
    unlockedCount: '{n} de {total} desbloqueados',
  },
  recs: {
    more_data: 'Pruebas que faltan para recibir recomendaciones personalizadas: {needed}.',
    practice_weak_keys: 'Tus teclas débiles son {keys}. La «{worst}» falla un {rate} % de las veces (tu media es {average} %).',
    practice_slow_keys: 'Tardas más en las teclas {keys} (≈{latency} ms por pulsación). Practícalas para ganar fluidez.',
    practice_bigrams: 'Las combinaciones {bigrams} concentran errores (hasta un {rate} %).',
    practice_words: 'Repite estas palabras que sueles fallar: {words}.',
    focus_accuracy: 'Tu precisión media es del {accuracy} %. Reduce un poco la velocidad hasta superar el {goal} %.',
    push_speed: 'Tu precisión es excelente. Es momento de apretar: objetivo {goal} WPM.',
    advance_level: '¡Listo para el nivel {next}! Últimas 5 pruebas: {wpm} WPM y {accuracy} %.',
    review_basics: 'Repasa las lecciones de principiante para consolidar la posición de las manos.',
  },
  profile: {
    title: 'Perfil',
    joined: 'Miembro desde {date}',
    privateProfile: 'Este perfil es privado.',
    notFound: 'No existe ese usuario.',
    records: 'Récords personales',
    achievements: 'Logros',
    stats: 'Estadísticas públicas',
    statsHidden: 'Las estadísticas de este perfil están ocultas.',
    edit: 'Editar perfil',
    streak: 'Racha actual',
    longestStreak: 'Mejor racha',
    noAchievements: 'Todavía no hay logros.',
  },
  settings: {
    title: 'Ajustes',
    sections: { appearance: 'Apariencia', typing: 'Escritura', language: 'Idioma y teclado', profile: 'Perfil', privacy: 'Privacidad', security: 'Seguridad' },
    theme: 'Tema',
    themeLocked: 'Bloqueado · {requirement}',
    unlockLevel: 'nivel {level}',
    unlockAchievement: 'logro «{name}»',
    accent: 'Color de acento',
    accentReset: 'Usar el del tema',
    fontSize: 'Tamaño del texto de escritura',
    caret: 'Cursor',
    caretStyles: { line: 'Línea', block: 'Bloque', underline: 'Subrayado' },
    stopOnError: 'Detenerse en los errores (no avanzar hasta acertar)',
    showKeyboard: 'Mostrar teclado en pantalla',
    sound: 'Sonido al pulsar teclas',
    uiLanguage: 'Idioma de la interfaz',
    exerciseLanguage: 'Idioma de los ejercicios',
    layout: 'Distribución de teclado',
    displayName: 'Nombre visible',
    avatar: 'Avatar',
    avatarColor: 'Color del avatar',
    country: 'País',
    noCountry: 'Sin especificar',
    bio: 'Biografía',
    visibility: 'Visibilidad del perfil',
    visibilityHint: 'Un perfil privado solo muestra tu nombre de usuario en los rankings.',
    showStats: 'Mostrar mis estadísticas en el perfil público',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    passwordChanged: 'Contraseña actualizada. Se cerraron tus otras sesiones.',
    deleteAccount: 'Eliminar cuenta',
    deleteWarning: 'Se borrarán de forma permanente tu perfil, historial, estadísticas, logros y certificados.',
    deleteConfirm: 'Escribe tu contraseña para confirmar',
    deleted: 'Tu cuenta se ha eliminado.',
    guestNotice: 'Estos ajustes se guardan en tu navegador. Inicia sesión para sincronizarlos.',
  },
  themes: { midnight: 'Medianoche', paper: 'Papel', ocean: 'Océano', forest: 'Bosque', sand: 'Arena', mono: 'Mono', sunset: 'Atardecer', neon: 'Neón', sakura: 'Sakura' },
  auth: {
    loginTitle: 'Bienvenido de nuevo',
    loginSubtitle: 'Entra para guardar tu progreso y competir.',
    registerTitle: 'Crea tu cuenta gratuita',
    registerSubtitle: 'Guarda tu historial, gana logros y entra en los rankings.',
    identifier: 'Usuario o email',
    username: 'Nombre de usuario',
    usernameHint: '3–24 caracteres: letras, números y guion bajo.',
    email: 'Email',
    emailHint: 'Puedes usarlo para entrar, igual que tu usuario. Nunca se muestra públicamente.',
    password: 'Contraseña',
    passwordHint: 'Mínimo 8 caracteres. Mejor una frase larga. Guárdala bien: por ahora no se puede recuperar.',
    submitLogin: 'Entrar',
    submitRegister: 'Crear cuenta',
    noAccount: '¿No tienes cuenta?',
    haveAccount: '¿Ya tienes cuenta?',
    privacy: 'Al registrarte aceptas que guardemos tus resultados para mostrarte estadísticas. No compartimos tus datos.',
    welcome: '¡Hola, {name}!',
    loggedOut: 'Has cerrado sesión.',
    passwordStrength: { weak: 'Débil', fair: 'Aceptable', strong: 'Fuerte' },
  },
  certs: {
    title: 'Certificados',
    subtitle: 'Certifica tu velocidad con una prueba clasificatoria de 60 o 120 segundos.',
    disclaimer: 'Los certificados de ManiType acreditan un resultado obtenido en la plataforma. No son una acreditación oficial ni académica.',
    requirements: 'Requisitos por categoría',
    requirementRow: '{category}: {wpm} WPM y {acc} % de precisión',
    eligible: 'Resultados que puedes certificar',
    noEligible: 'Aún no tienes resultados que cumplan los requisitos. Haz una prueba de 60 o 120 segundos.',
    issue: 'Emitir certificado',
    mine: 'Tus certificados',
    none: 'Todavía no tienes certificados.',
    view: 'Ver certificado',
    verifyTitle: 'Verificación de certificado',
    verifyCode: 'Código de verificación',
    verifyLookup: 'Verificar',
    valid: 'Certificado válido',
    revoked: 'Certificado revocado',
    notFound: 'No existe ningún certificado con ese código.',
    certTitle: 'Certificado de mecanografía',
    certifies: 'ManiType certifica que',
    achieved: 'ha alcanzado una velocidad de',
    withAccuracy: 'con una precisión del',
    inTest: 'en una prueba de {duration} segundos en {language}.',
    category: 'Categoría',
    issuedOn: 'Emitido el {date}',
    verifyAt: 'Verificable en {url}',
    categories: { basic: 'Básico', intermediate: 'Intermedio', advanced: 'Avanzado', expert: 'Experto' },
  },
  admin: {
    title: 'Administración',
    tabs: { overview: 'Resumen', users: 'Usuarios', content: 'Contenido', reports: 'Reportes', certificates: 'Certificados', audit: 'Auditoría', settings: 'Configuración' },
    overview: {
      users: 'Usuarios', new_users_week: 'Nuevos (7 días)', results_today: 'Resultados hoy', flagged_results: 'Resultados en revisión',
      security_events_day: 'Eventos de seguridad (24 h)', texts: 'Textos', lessons: 'Lecciones', certificates: 'Certificados activos',
    },
    resources: { courses: 'Cursos', lessons: 'Lecciones', exercises: 'Ejercicios', texts: 'Textos', achievements: 'Logros', challenges: 'Desafíos', games: 'Juegos', languages: 'Idiomas' },
    role: 'Rol',
    roles: { user: 'Usuario', editor: 'Editor', admin: 'Administrador', superadmin: 'Superadministrador' },
    suspend: 'Suspender',
    activate: 'Reactivar',
    statuses: { active: 'Activo', suspended: 'Suspendido' },
    flagged: 'Resultados marcados',
    security: 'Eventos de seguridad',
    approve: 'Aprobar',
    reject: 'Rechazar',
    revoke: 'Revocar',
    revokeReason: 'Motivo de la revocación',
    newItem: 'Nuevo elemento',
    editItem: 'Editar elemento',
    confirmDelete: '¿Eliminar este elemento? La acción no se puede deshacer.',
    jsonHint: 'Formato JSON',
    settingsKeys: { registration_open: 'Registro abierto', races_enabled: 'Carreras activadas', announcement: 'Anuncio en la portada' },
    noPermission: 'No tienes permisos para esta sección.',
    actor: 'Autor',
    action: 'Acción',
    entity: 'Entidad',
    details: 'Detalles',
    lastLogin: 'Último acceso',
    flags: 'Señales',
    filter: 'Filtrar',
    saved: 'Cambios guardados',
  },
  achievements: {
    title: 'Logros',
    locked: 'Bloqueado',
    unlockedOn: 'Desbloqueado el {date}',
    reward: 'Recompensa: tema {theme}',
  },
  errors: {
    network_error: 'No se pudo conectar con el servidor. Comprueba tu conexión.',
    invalid_credentials: 'Usuario o contraseña incorrectos.',
    username_taken: 'Ese nombre de usuario ya existe.',
    email_taken: 'Ese email ya está registrado.',
    validation_error: 'Revisa los campos marcados.',
    account_suspended: 'Esta cuenta está suspendida.',
    registration_closed: 'El registro está cerrado temporalmente.',
    rate_limited: 'Demasiados intentos. Espera un minuto.',
    unauthorized: 'Necesitas iniciar sesión.',
    forbidden: 'No tienes permiso para hacer esto.',
    insufficient_role: 'No tienes permiso para hacer esto.',
    not_found: 'No encontrado.',
    theme_locked: 'Ese tema todavía está bloqueado.',
    result_rejected: 'El resultado no superó la validación.',
    test_expired: 'La prueba ha caducado. Empieza otra.',
    test_already_submitted: 'Esta prueba ya se envió.',
    challenge_closed: 'Este desafío ya ha terminado.',
    certificate_already_issued: 'Ya existe un certificado para ese resultado.',
    certificate_requirements_not_met: 'Ese resultado no cumple los requisitos.',
    room_not_found: 'La sala no existe o ha caducado.',
    room_full: 'La sala está llena.',
    race_in_progress: 'La carrera ya ha empezado.',
    not_enough_players: 'Se necesitan al menos 2 jugadores.',
    races_disabled: 'Las carreras están desactivadas temporalmente.',
    guest_required: 'No se pudo preparar tu plaza de invitado. Recarga la página.',
    invalid_guest_name: 'Elige un apodo de 3 a 20 letras o números.',
    too_many_rooms: 'Hay demasiadas salas abiertas. Únete a una o inténtalo en un momento.',
    cannot_modify_self: 'No puedes modificar tu propia cuenta desde aquí.',
    duplicate_value: 'Ya existe un elemento con ese valor.',
    invalid_reference: 'La referencia no existe.',
    constraint_violation: 'Los datos no cumplen las restricciones.',
    no_texts_available: 'No hay textos disponibles para esa combinación.',
    internal_error: 'Error interno. Inténtalo de nuevo.',
    default: 'Se produjo un error inesperado ({code}).',
  },
  footer: {
    about: 'ManiType es una plataforma gratuita para aprender y mejorar la mecanografía.',
    formulas: 'Cómo medimos',
    verify: 'Verificar certificado',
    rights: 'Contenido original del proyecto ManiType.',
  },
  notFound: {
    title: 'Página no encontrada',
    text: 'La página que buscas no existe o se ha movido.',
    home: 'Volver al inicio',
  },
};

export default es;
